type ViteEnv = {
  VITE_SUPABASE_URL: string;
  VITE_SUPABASE_ANON_KEY: string;
  VITE_BASEMAP_URL: string;
  VITE_POPULATION_BLOB_URL: string;
};

function read(key: keyof ViteEnv): string {
  const value = import.meta.env[key] as string | undefined;
  if (!value || value.length === 0) {
    throw new Error(
      `Missing required environment variable: ${key}. Set it in .env.local at the project root.`
    );
  }
  return value;
}

export const env: ViteEnv = {
  get VITE_SUPABASE_URL() {
    return read('VITE_SUPABASE_URL');
  },
  get VITE_SUPABASE_ANON_KEY() {
    return read('VITE_SUPABASE_ANON_KEY');
  },
  get VITE_BASEMAP_URL() {
    return read('VITE_BASEMAP_URL');
  },
  get VITE_POPULATION_BLOB_URL() {
    return read('VITE_POPULATION_BLOB_URL');
  },
};
